<h1 mat-dialog-title>{{ 'Bind skill' | translate }}</h1>
<div mat-dialog-content>
  <ng-container *ngIf="!isLoading; else loading">

    <!-- Skill -->
    <mat-form-field *ngIf="data.isNew" appearance="fill">
      <mat-label>{{ 'Skill' | translate }}</mat-label>
      <mat-select [(ngModel)]="data.skillId" [ngModelOptions]="{standalone: true}" required>
        <mat-option>
          <ngx-mat-select-search [placeholderLabel]="'Search skills...' | translate" [(ngModel)]="skillFilter" [ngModelOptions]="{standalone: true}"></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngIf="!skills || filteredSkills.length == 0">{{ 'No skill found' | translate }}</mat-option>
        <mat-option *ngFor="let skill of filteredSkills" [value]="skill.id">
          {{skill.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Skill level -->
    <mat-form-field appearance="fill">
      <mat-label>{{ 'Skill level' | translate }}</mat-label>
      <mat-select [(ngModel)]="data.skillLevelId" [ngModelOptions]="{standalone: true}" required>
        <mat-option>
          <ngx-mat-select-search [placeholderLabel]="'Search skill levels...' | translate" [(ngModel)]="skillLevelFilter" [ngModelOptions]="{standalone: true}"></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngIf="!skillLevels || filteredSkillLevels.length == 0">{{ 'No skill found' | translate }}</mat-option>
        <mat-option *ngFor="let skillLevel of filteredSkillLevels" [value]="skillLevel.id">
          {{skillLevel.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

  </ng-container>
</div>
<div *ngIf="!isLoading" mat-dialog-actions class="actions">
  <button mat-stroked-button (click)="onNoClick()">{{ 'Cancel' | translate }}</button>
  <div>
    <button mat-flat-button color="primary" [mat-dialog-close]="finalData" cdkFocusInitial [disabled]="!validate()">{{ 'Save' | translate }}</button>
  </div>
</div>

<ng-template #loading>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>
